import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "SpellCheck"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M15 16.5H16.5L12.75 7.5H11.25L7.5 16.5H9L9.93 14.25H14.0775L15 16.5ZM10.5525 12.75L11.9175 9.435H12.105L13.5 12.75H10.5525Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M9 21H4.5C4.10218 21 3.72064 20.842 3.43934 20.5607 3.15804 20.2794 3 19.8978 3 19.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934 3.72064 3.15804 4.10218 3 4.5 3H19.5C19.8978 3 20.2794 3.15804 20.5607 3.43934 20.842 3.72064 21 4.10218 21 4.5V12.75H19.5V4.5H4.5V19.5H9V21zM17.25 20.385 15.3075 18.4425 14.25 19.5 17.25 22.5 22.5 17.25 21.4425 16.1925 17.25 20.385z" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/SpellCheck.vue"]]);
